import axios from "axios";
import router from "@/router";
import { store } from "@/main";

class ApiConnection {
  fetchApi(method, path, params, token = null) {
    store.setError(null);
    let headers = {};

    if (params) {
      headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
    }

    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }

    const call = axios({
      method: method,
      url: path,
      data: params,
      headers: headers,
      origin: "*",
    });

    return new Promise((resolve) => {
      call
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          store.setLoading(false);
          if (error.response.status === 422) {
            resolve("wait");
          } else if (
            error.response.status === 400 &&
            error.response.data.message === "Action déjà effectuée"
          ) {
            resolve({ success: false });
          } else {
            store.setError(error);
            resolve("stop");
            router.push({ name: "Error" });
          }
        });
    });
  }
}

export const apiConnection = new ApiConnection();
